module.exports = __webpack_public_path__ + "static/media/camera.a621fe7c.svg";